import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, GetAllCardsResponse } from '@shared/api';

interface CardsLatestType {
  data: GetAllCardsResponse | null;
  loading: boolean;
  error: string | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCardsLatestStore = create<CardsLatestType>((set) => ({
  data: null,
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.getCardsLatest(signal);
      set({ data: result ?? null, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, error: null }),
}));
